

class Core {
    constructor() {
        this.currentTimeout = null;
    };
    wait(timeout) {
        if (this.currentTimeout) {
            clearTimeout(this.currentTimeout);
        };
        return new Promise(resolve => {
            this.currentTimeout = setTimeout(resolve, timeout);
        });
    };
};

window.addEventListener("load", function () {
    // Handle milestone item click - remove 'off' class from milestone-real
    $('.gr_milestone--item.item-3 .btn.active').on('click', function() {
        $('.milestone-real.active-3 .btn').removeClass('off');
    });

    $('.gr_milestone--item.item-5 .btn.active').on('click', function() {
        $('.milestone-real.active-5 .btn').removeClass('off');
    });
});
